import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_503 implements Validator {

    public static id = 'CTRL_503';
    private message = 'error.ctr_503';


    public LOG: LogService = new LogService(CTRL_503);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_503.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];

                const fournituresAchatNameWithStepId = map.get(ctrl.value.rgCtrls.natureMarcheFournituresAchat);
                const fournituresCreditBailNameWithStepId = map.get(ctrl.value.rgCtrls.natureMarcheFournituresCreditBail);
                const fournituresLocationNameWithStepId = map.get(ctrl.value.rgCtrls.natureMarcheFournituresLocation);
                const fournituresLocationVenteNameWithStepId = map.get(ctrl.value.rgCtrls.natureMarcheFournituresLocationVente);
                const fournituresPlusieursFormesNameWithStepId = map.get(ctrl.value.rgCtrls.natureMarcheFournituresPlusieursFormes);
                const servicesNameWithStepId = map.get(ctrl.value.rgCtrls.natureMarcheServices);
                const travauxConceptionRealisationNameWithStepId = map.get(ctrl.value.rgCtrls.natureMarcheTravauxConceptionRealisation);
                const travauxExecutionNameWithStepId = map.get(ctrl.value.rgCtrls.natureMarcheTravauxExecution);
                const travauxExecutionOuvrageNameWithStepId = map.get(ctrl.value.rgCtrls.natureMarcheTravauxExecutionOuvrage);
                const fournituresAchatCtrl = form.controls[fournituresAchatNameWithStepId];
                const fournituresCreditBailCtrl = form.controls[fournituresCreditBailNameWithStepId];
                const fournituresLocationCtrl = form.controls[fournituresLocationNameWithStepId];
                const fournituresLocationVenteCtrl = form.controls[fournituresLocationVenteNameWithStepId];
                const fournituresPlusieursFormesCtrl = form.controls[fournituresPlusieursFormesNameWithStepId];
                const servicesCtrl = form.controls[servicesNameWithStepId];
                const travauxConceptionRealisationCtrl = form.controls[travauxConceptionRealisationNameWithStepId];
                const travauxExecutionCtrl = form.controls[travauxExecutionNameWithStepId];
                const travauxExecutionOuvrageCtrl = form.controls[travauxExecutionOuvrageNameWithStepId];
                if ((fournituresAchatCtrl !== undefined && fournituresAchatCtrl.value) ||
                     (fournituresCreditBailCtrl !== undefined && fournituresCreditBailCtrl.value) ||
                     (fournituresLocationCtrl !== undefined && fournituresLocationCtrl.value) ||
                     (fournituresLocationVenteCtrl !== undefined && fournituresLocationVenteCtrl.value) ||
                     (fournituresPlusieursFormesCtrl !== undefined && fournituresPlusieursFormesCtrl.value) ||
                     (servicesCtrl !== undefined && servicesCtrl.value !== null) ||
                     (travauxConceptionRealisationCtrl !== undefined && travauxConceptionRealisationCtrl.value) ||
                     (travauxExecutionCtrl !== undefined && travauxExecutionCtrl.value) ||
                     (travauxExecutionOuvrageCtrl !== undefined && travauxExecutionOuvrageCtrl.value)) {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    } else {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}